import React from 'react'

export default function Author() {
  return (
    <div className='author'>
        <a className='signature' target="_blank" rel="noreferrer" href='https://instagram.com/why.be7'>WhyBe7<span>7</span></a>
    </div>
  )
}
